import React from 'react'
import * as R from 'ramda'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { Typography, makeStyles } from '@material-ui/core'

import { getHumanizeDate } from 'commons/date'
import Avatars from 'app/componentV4/Avatar/Avatars'
import SimpleDialog from 'app/componentV4/Dialog/SimpleDialog'

const useStyles = makeStyles({
  root: {
    '& .MuiDialog-paper': {
      width: '350px',
      maxHeight: '500px',
      overflowX: 'auto',
      padding: '2.5rem',
    },
  },
})

const SubscriberList = (props) => {
  const { subscribers, isOpen, title, onClose } = props
  const classes = useStyles()
  const { formatMessage } = useIntl()

  return (
    <SimpleDialog
      id={'metrics-subscriber-list'}
      open={isOpen}
      title={
        <div className="my-auto">
          <Typography className="text-18 font-bold text-primary">
            {title}
          </Typography>
          <Typography className="text-10 text-neutrals-400">
            {formatMessage(
              { id: 'metrics.subscribers' },
              {
                count: R.length(subscribers),
              },
            )}
          </Typography>
        </div>
      }
      onClose={onClose}
      className={classes.root}
    >
      {subscribers.map((subscriber, index) => (
        <div className="flex space-x-2 mt-10" key={`subscriber-list-${index}`}>
          <Avatars
            id={subscriber.id}
            name={`${subscriber.firstName} ${subscriber.lastName}`}
            src={subscriber.profilePicture}
            characters={subscriber.avatarCharacters}
          />
          <div className="m-auto">
            <Typography className="text-16">{`${subscriber.firstName} ${subscriber.lastName}`}</Typography>
            {R.isNil(subscriber.lastSeen) ? null : (
              <Typography className="text-10 text-neutrals-400">
                {formatMessage(
                  { id: 'subscriber.lastSeen.label' },
                  {
                    formattedDate: getHumanizeDate(subscriber.lastSeen),
                    dateCount: getHumanizeDate(subscriber.lastSeen).split(',')
                      .length,
                  },
                )}
              </Typography>
            )}
          </div>
        </div>
      ))}
    </SimpleDialog>
  )
}

const valuePropTypes = {
  id: PropTypes.number,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  profilePicture: PropTypes.string,
  avatarCharacters: PropTypes.string,
  lastSeen: PropTypes.string,
}
SubscriberList.propTypes = {
  subscribers: PropTypes.arrayOf(PropTypes.shape(valuePropTypes)).isRequired,
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
}

export default SubscriberList
